
import commonFetch from './commonFetch';
import type { DateRange } from '../types/dateRange';

export const tripsMonitoredReportUrl = '/api/trips/reports/monitored';

const getTripsMonitoredReport = (dateRange: DateRange) => {
  const dateFormatString = 'MM-DD-YYYY';
  return commonFetch(
    tripsMonitoredReportUrl,
    {
      dateStart: dateRange.startDate.format(dateFormatString),
      dateEnd: dateRange.endDate.format(dateFormatString),
    },
    'POST',
  );
};

export default getTripsMonitoredReport;
